import React, { useState, useEffect } from "react"
import QuotesContext from "../../context/QuotesContext"
import ClutchQuote from "../organisms/ClutchQuote"
import { useStaticQuery, graphql } from "gatsby"

const query = graphql`
  {
    allStrapiQuotes {
      nodes {
        quoteClutchRating
        quoteCompanyName
        quotePersonName
        quotePersonPosition
        quoteText
      }
    }
  }
`

const PageWrapper = ({ children, props }) => {
  const [activeQuote, setActiveQuote] = useState(0)
  const [numOfQuotes, setNumOfQuotes] = useState(20)
  const [showQuote, setShowQuote] = useState(false)
  const value = {
    activeQuote,
    setActiveQuote,
    numOfQuotes,
    setNumOfQuotes,
    showQuote,
    setShowQuote,
  }
  const data = useStaticQuery(query)
  const queriedQuotes = data.allStrapiQuotes.nodes

  useEffect(() => {
    setNumOfQuotes(queriedQuotes.length)
  }, [])
  return (
    <QuotesContext.Provider value={value}>
      {children}
      <div className={`quoteWrapper ${showQuote ? "active" : ""}`}>
        <ClutchQuote
          text={queriedQuotes[activeQuote].quoteText}
          name={queriedQuotes[activeQuote].quotePersonName}
          company={queriedQuotes[activeQuote].quoteCompanyName}
          rating={queriedQuotes[activeQuote].quoteClutchRating}
          position={queriedQuotes[activeQuote].quotePersonPosition}
        />
      </div>
    </QuotesContext.Provider>
  )
}

export default PageWrapper
